<!-- Effacer les ligne 1 a 5 après avoir completé
Mettre l'id : ligne 7
Mettre le nom : ligne 59
-->

<template>
    <div id="debugIndex">
        <b-row class="backInfoMain2">

            <!--<s-menuSave :msg="sendMsg" newBtn :btnSaveDisabled="checkAllField" @new="menuNew()" saveBtn @save="menuSave()" deleteBtn @delete="menuDelete(activeObj.id)"></s-menuSave>-->
            <menuSave 
                :msg="sendMsg" 
                :msgText="sendMsg2"
                :msgType="getTheme.warning">
            </menuSave>

            <!--Section de gauche-->
            <b-col :xs="pSize.left.xs" :sm="pSize.left.sm" :md="pSize.left.md" :lg="pSize.left.lg" :xl="pSize.left.xl">
                <div>
<!--{{fromApi}}-->


                    <!--Affichage de la liste-->
                    <b-row>
                        <s-itemList 
                            v-if="fromApi"
                            style="width: 100%" 
                            :content="fromApi" 
                            :returnValue.sync="activeObj" 
                            showFieldAux="showField" 
                            showField="count" 
                            activeField="isActive" 
                            :selectedItems="activeObj">
                        </s-itemList>
                    </b-row>                            
                </div>
            </b-col>
            <!--Fin section de gauche-->

<!--****************************************************************************************************************************************************************-->
            
            <!--Section de centre-->
            <b-col :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" :xl="3">
                <!--{{fromApi}}<br><br><br>
                {{activeObj}}-->

                <b-row style="margin-top: 5px">
                    <b-table striped hover :bordered="true" :head-variant="getTheme.dark" :items="activeObj.erList" :fields="fields">
                        <template v-slot:cell(message)="data">
                            <div :style="'minWidth: 600px; maxWidth: 600px; word-wrap: break-word;'">{{ data.value }}</div>
                        </template>
                        <template v-slot:cell(sourceFilePath)="data">
                            <div :style="'minWidth: 150px; maxWidth: 150px; word-wrap: break-word;'">{{ data.value }}</div>
                        </template>
                    </b-table>
                </b-row>
                


            </b-col>
            <!--FIN - Section de centre-->

            <!--Section de droite-->
            <!--<b-col xs="12" sm="12" md="12" lg="12" xl="5">
                {{fromApi[0].showField}}
            </b-col>-->
            <!--FIN - Section de droite-->

            <br><br>
            
        </b-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios';

import menuSave from '@/components/general/s-menuSave/s-menuSave.vue'

export default{
    name: "debugIndex",
    components: {
        menuSave
    },
    data() {
        return{
            sendMsg2: "************* Mode débug / Debug mode *************",
            fields: [
              {
                key: 'dateCreated',
                label: "Date",
                sortable: true
              },
              {
                key: 'licence',
                label: "Licence",
                sortable: true
              },
              {
                key: 'store',
                label: "Store",
                sortable: true
              },
              {
                key: 'source',
                label: "Source",
                sortable: true
              },
              {
                key: 'message',
                label: "Message",
                sortable: true,
              },
              {
                key: 'sourceFilePath',
                label: "Path",
                sortable: true,
              },
              {
                key: 'sourceLineNumber',
                label: "Ligne",
                sortable: true,
              }
            ],
            apiAddGet1: this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.debug.apiLogEr, //adress de la requete principale vers l'API
            apiAddPost1: this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.debug.apiLogEr, //adress de la requete principale vers l'API
            pSize: this.$store.getters.getPageSize, //Taille des section droite/gauche
            chkSize: this.$store.getters.getCheckSize,
            //sendMsg: 'MODE DEBUG / DEBUG MODE', //message a utiliser pour le menu en haut de la page New/Save/Delete
            sendMsg: '-',
            output: 'null', //Message de reception de l'API
            error: null, //Message d'erreur de l'API
            fromApi: null, //Contenu de l'API
            InitialState: null, //Format initial de : activeObj
            //Objet en cours de modification
            activeObj:{
                id: 0,
                dateCreer: null,
                dateModif: null,
                actif: true,
            },
        }
    },
    methods: {
        pushto(link) {
            this.$router.push(link)
        },
        resetAll(){
            this.activeObj = this.$CObj(this.InitialState)
        },
        menuNew(){
            this.resetAll()
        },
        loadApi() {
            this.sendMsg = '4'
            
            axios.get(this.apiAddGet1 + '?' + this.getApiKey + '&licence=' + this.$store.getters.getworkLicence, {headers: {'Authorization': `Basic ${this.$CKey()}`}})
                .then(response => {
                  this.fromApi = response.data
                  this.sendMsg = ''
                  
                })
                .catch(e => {
                  this.errors.push(e)
                  this.sendMsg = '2'
                  
                }) 
        },
        menuSave(){
            this.sendMsg = '-'
            let currentObj = this;
            let t = this.activeObj

            if (t.id == 0) //CRÉATION D'UN NOUVEAU
            {
                axios.post(this.apiAddPost1 + '?' + this.getApiKey + '&licence=' + this.$store.getters.getworkLicence, {
                    //id: t.id,
                }, {headers: {'Authorization': `Basic ${this.$CKey()}`}})
                .then(function (response) {
                    currentObj.sendMsg = '1'
                    currentObj.output = response.data;
                })
                .catch(function (error) {
                    currentObj.sendMsg = '2'
                    currentObj.output = error;
                });
            }
            else //MODIFICATION D'UN EXISTANT
            {
                axios.patch(this.apiAddPost1 + '?' + this.getApiKey + '&licence=' + this.$store.getters.getworkLicence, {
                    //id: t.id,
                }, {headers: {'Authorization': `Basic ${this.$CKey()}`}})
                .then(function (response) {
                    currentObj.sendMsg = '1'
                    currentObj.output = response.data;
                })
                .catch(function (error) {
                    currentObj.sendMsg = '2'
                    currentObj.output = error;
                });


            }
                setTimeout(() => { this.sendMsg = '' }, 5000)
        },
        menuDelete(id){
            if (this.activeObj.id != '0')
                {
                    this.sendMsg = '-'
                    this.output = null
                    let currentObj = this;
                    axios.delete(this.apiAdd1 + '?' + this.apiAddPost1 + '&licence=' + this.$store.getters.getworkLicence + '&id=' + id + '&status=false', {headers: {'Authorization': `Basic ${this.$CKey()}`}})
                    .then(function (response) {
                        currentObj.sendMsg = '1'
                        currentObj.output = response.data;
                    })
                    .catch(function (error) {
                        currentObj.sendMsg = '2'
                        currentObj.output = error;
                    });

                    setTimeout(() => { this.sendMsg = '' }, 5000)

                }
        }
    },

 //------------------------------------------------------------------------------------------------
    computed: {
        ...mapGetters(['getTheme', 'getApiAdress', 'getApiAdd', 'getPageSize', 'getworkLicence', 'getApiKey', 'getCombo', 'getCheckSize']),
        checkAllField() {
            //if (this.activeObj.NomFonction == '')
            //{return true}
            //else
            //{return false}
            return false
        },
    },
//------------------------------------------------------------------------------------------------
    mounted() {
        this.loadApi() //charger les licences
        this.InitialState = this.$CObj(this.activeObj)
    },
//------------------------------------------------------------------------------------------------
    watch: {
        sendMsg: function() {
            if (this.sendMsg == '1')
            {
                this.resetAll()
                this.loadApi()
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>